import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CoreSolutions from "./components/CoreSolutions";
import InteractiveCanvas from "./components/InteractiveCanvas";
import PricingSection from "./components/PricingSection";
import FAQSection from "./components/FAQSection";
import ProcessTimeline from "./components/ProcessTimeline";
import CaseStudies from "./components/CaseStudies";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-brand-bg text-white font-body overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <CoreSolutions />
        <CaseStudies />
        <InteractiveCanvas />
        <PricingSection />
        <FAQSection />
        <ProcessTimeline />
      </main>
      <Footer />
    </div>
  );
}
